import { useState, useEffect } from 'react';

export const getDeviceType = (
  userAgent: string
): 'desktop' | 'mobile' | 'tablet' | 'unknown' => {
  if (!userAgent) return 'unknown';

  if (userAgent.indexOf('Mobi') !== -1) return 'mobile';
  if (userAgent.indexOf('Tablet') !== -1) return 'tablet';
  return 'desktop';
};

export function useDeviceType() {
  const [deviceType, setDeviceType] = useState<
    'desktop' | 'mobile' | 'tablet' | 'unknown' | undefined
  >(undefined);

  useEffect(() => {
    if (typeof navigator !== 'undefined') {
      setDeviceType(getDeviceType(navigator.userAgent));
    }
  }, []);

  return deviceType;
}
